import moment, { Moment } from 'moment';
import { useState } from 'react';

import { Routes } from '@common/constants';
import { parseDateToString } from '@utils/helpers';
import { useRouter } from 'shared-routing';
import { SelectOptionType } from 'shared-types/Common';

type UseSpaDaysFilterParams = {
  categoryId: number | null;
  arrivalDate: string | undefined;
  fromDate: string | undefined;
  changeJourneyParam: (dateId: string, date?: string | Moment | number) => void;
};

export function useSpaDaysFilter({
  categoryId,
  arrivalDate,
  fromDate,
  changeJourneyParam,
}: UseSpaDaysFilterParams) {
  const router = useRouter();

  const today = moment().format();
  const initialDate = arrivalDate || fromDate || today;

  const [categoryFilterId, setCategoryFilterId] = useState<number | null>(categoryId);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(
    categoryId ? String(categoryId) : null
  );
  const [pickerDate, setPickerDate] = useState(initialDate);
  const [appliedDate, setAppliedDate] = useState(initialDate);

  const appliedDateString = appliedDate
    ? moment(appliedDate).format('YYYY-MM-DD')
    : moment().format('YYYY-MM-DD');

  const handleCategoryChange = ({ value }: SelectOptionType): void => {
    const newValue = value ? String(value) : null;
    setSelectedCategory(newValue);
  };

  const handleUpdate = () => {
    setAppliedDate(pickerDate);

    const params = {
      category: selectedCategory ? selectedCategory : '',
      arrivalDate: parseDateToString(pickerDate),
    };
    router.push({ pathname: Routes.SPA_DAY_LIST, query: params as any }, undefined, {
      shallow: true,
    });

    if (String(selectedCategory) !== String(categoryFilterId)) {
      setCategoryFilterId(
        !selectedCategory || isNaN(Number(selectedCategory)) ? null : Number(selectedCategory)
      );
    }

    changeJourneyParam('spaDate', pickerDate);
    changeJourneyParam('category', selectedCategory ?? undefined);
  };

  return {
    categoryFilterId,
    appliedDateString,
    pickerDate,
    selectedCategory,
    setPickerDate,
    handleCategoryChange,
    handleUpdate,
  };
}
